import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  paper: {
    padding: '1rem',
    marginBottom: '1rem',
    display: 'flex'
  },
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(1),
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      gap: theme.spacing(2)
    }
  },
  form: {
    display: 'flex',
    width: '-webkit-fill-available',
    paddingTop: 5
  },
  field: {
    display: 'flex',
    marginTop: 10,
    flexGrow: 1,
    minWidth: 200,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 250
    }
  },
  input: {
    display: 'flex',
    flexGrow: 1,
    marginTop: 5
  }
}))

export default useStyles
